import {Command} from '@application/command/command';
import {CalendarItemGroup} from '@domain/planning/calendar-item-group';
import {PlanningItem} from '@domain/planning/planning-item';
import {moment, TimeUtils} from '@vdw/angular-component-library';
import {filter, forEach, isEqual, orderBy} from 'lodash-es';
import {RescheduleOverlappingItemsParameters} from './reschedule-overlapping-items-parameters';

export class RescheduleOverlappingItemsCommand implements Command<RescheduleOverlappingItemsParameters, void> {
  public execute(commandArgs: RescheduleOverlappingItemsParameters): void {
    const {planningItem, groupedCalendarItem} = commandArgs;

    this.rescheduleOverlappingPlanningItems(planningItem, groupedCalendarItem);
  }

  private findOverlappingPlanningItems(lastRescheduledPlanningItem: PlanningItem, groupedCalendarItem: CalendarItemGroup): PlanningItem[] {
    return orderBy(
      filter(groupedCalendarItem.items as PlanningItem[], (planningItem: PlanningItem) => {
        const lastRescheduledRunDateRange = moment.range(lastRescheduledPlanningItem.startDate, lastRescheduledPlanningItem.endDate);
        const planningItemDateRange = moment.range(planningItem.startDate, planningItem.endDate);

        return lastRescheduledRunDateRange.overlaps(planningItemDateRange) && !isEqual(lastRescheduledPlanningItem.uniqueId, planningItem.uniqueId);
      }),
      'startDate',
      'asc'
    );
  }

  private rescheduleOverlappingPlanningItems(planningItem: PlanningItem, groupedCalendarItem: CalendarItemGroup): void {
    const overlappingPlanningItems: PlanningItem[] = this.findOverlappingPlanningItems(planningItem, groupedCalendarItem);

    forEach(overlappingPlanningItems, (overlappingPlanningItem: PlanningItem) => {
      const overlappingPlanningItemNewStartDate = moment(planningItem.endDate).add(1, 'minutes').toDate();
      const overlappingPlanningItemNewEndDate = moment(overlappingPlanningItemNewStartDate).add(overlappingPlanningItem.totalRunningTimeInMs, TimeUtils.MILLISECONDS_UNIT).toDate();
      overlappingPlanningItem.reschedule(overlappingPlanningItemNewStartDate, overlappingPlanningItemNewEndDate);

      this.rescheduleOverlappingPlanningItems(overlappingPlanningItem, groupedCalendarItem);
      planningItem = overlappingPlanningItem;
    });
  }
}
